
import { Component, Mixins } from 'vue-property-decorator';
import NetatmoIcon from '~/components/NetatmoIcon.vue';
import { topologyPrefixConstant } from '~/constants/topologyPrefix.constant';
import { ListRights } from '~/interfaces/operator.interface';
import SearchMixin from '~/mixins/search.mixin';
import { OperatorModule } from '~/store/modules/operator';
import { SearchModule } from '~/store/modules/search';

@Component({
    components: { NetatmoIcon },
})
export default class SearchBar extends Mixins(SearchMixin) {
    searchText = '';

    get prefixes(): Array<{ text: string, prefix: string }> {
        return this.getAvailableSearchFromRights(OperatorModule.adminRawRights);
    }

    get selectedPrefix() {
        return SearchModule.selectedPrefix;
    }

    set selectedPrefix(prefix: string) {
        SearchModule.setSelectedPrefix(prefix);
    }

    mounted(): void {
        if (this.prefixes.length > 0) {
            const localStoragePrefix = window.localStorage.getItem('searchPrefix');
            if (typeof localStoragePrefix === 'string' && this.prefixes.map(prefix => prefix.prefix).includes(localStoragePrefix)) {
                this.selectedPrefix = localStoragePrefix;
            } else {
                this.selectedPrefix = this.prefixes[0].prefix;
            }
        }
    }

    getAvailableSearchFromRights = (rights: Record<string, ListRights>): any => {
        const listRights = Object.entries(rights).map(([scope, scopeRights]) => {
            return {
                name: scope,
                rights: scopeRights.listRights,
                type: scopeRights.type,
            };
        });
        const topologyScopes = listRights.filter((scope) => scope.type === 'topology_type');

        const namesTopologies = topologyScopes.map((scope) => scope.name.toLowerCase().replace('topology', ''));

        const initListMappedTopologies = [];
        for (const name in namesTopologies) {
            const currentName = namesTopologies[name];
            if (topologyPrefixConstant[currentName]) {
                for (const prefix in topologyPrefixConstant[currentName]) {
                    initListMappedTopologies.push(topologyPrefixConstant[currentName][prefix]);
                }
            }
        }
        return initListMappedTopologies;
    };

}
